/**
 * Logging utilities for frontend components
 * Uses secureLogger to prevent sensitive data leaks
 */
import { secureLogger } from './secureLogger';

export const logComponentError = (component: string, action: string, error: any, context?: any) => {
  secureLogger.error(`[${component}] Error during ${action}:`, error, context);
};

export const logComponentWarn = (component: string, message: string, context?: any) => {
  secureLogger.warn(`[${component}] ${message}`, context);
};

export const logComponentDebug = (component: string, message: string, context?: any) => {
  secureLogger.debug(`[${component}] ${message}`, context);
};

export const logComponentInfo = (component: string, message: string, context?: any) => {
  secureLogger.info(`[${component}] ${message}`, context);
};
